import NewVoiceEvent from './NewVoiceEvent';
import ManualDialerEvent from './ManualDialerEvent';
import HangupEvent from './HangupEvent';
import DialerPreferentialCallEvent from './DialerPreferentialCallEvent';
import DialerAutoEvent from './DialerAutoEvent';
import VoiceOnHoldEvent from './VoiceOnHoldEvent';
import AgentVoiceOpenUrlEvent from './AgentVoiceOpenUrlEvent';
import VoiceTransferEvent from './VoiceTransferEvent';
import VoiceTransferRequestEvent from './VoiceTransferRequestEvent';
import VoiceTransferResponseEvent from './VoiceTransferResponseEvent';
import VoiceRedialEvent from './VoiceRedialEvent';
import VoiceConferenceStartEvent from './VoiceConferenceStartEvent';
import VoiceConferenceStopEvent from './VoiceConferenceStopEvent';
import ManualCallStatusEvent from './ManualCallStatusEvent';
import VoiceAgentCalledEvent from './VoiceAgentCalledEvent';
import RefreshAgentConfFileDataEvent from './RefreshAgentConfFileDataEvent';
import VoiceTransferAcceptedEvent from './VoiceTransferAcceptedEvent';

export default {
  NewVoiceEvent,
  ManualDialerEvent,
  HangupEvent,
  DialerPreferentialCallEvent,
  DialerAutoEvent,
  VoiceOnHoldEvent,
  AgentVoiceOpenUrlEvent,
  VoiceTransferEvent,
  VoiceTransferRequestEvent,
  VoiceTransferResponseEvent,
  VoiceRedialEvent,
  VoiceConferenceStartEvent,
  VoiceConferenceStopEvent,
  ManualCallStatusEvent,
  VoiceAgentCalledEvent,
  RefreshAgentConfFileDataEvent,
  VoiceTransferAcceptedEvent,
};
